import { useSupporter } from '../state/SupporterContext';
import { Button } from './Button';

/**
 * Shows a "Support ClueVine" button (when a Stripe link is configured and the
 * player hasn't supported yet), or a quiet Supporter badge once they have.
 * Renders nothing if no link is configured and they're not a supporter.
 */
export function SupportButton({ size = 'sm' }: { size?: 'sm' | 'md' | 'lg' }) {
  const { isSupporter, canSupport, openSupport } = useSupporter();

  if (isSupporter) {
    return <span className="cv-chip cv-chip--seed">🌱 Supporter</span>;
  }
  if (!canSupport) return null;

  return (
    <Button variant="ghost" size={size} onClick={openSupport}>
      🌱 Support ClueVine
    </Button>
  );
}
